var layout_default = {
  "layoutWrapper": "Hd54A",
  "layout": "_9i2Wr",
  "cell": "GpEVk"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
